import Core from '@/core/module';
import '@/vendor/customselect';

export default class Customselect extends Core {
    init() {
        this.$el.customselect();
    }
}